var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.996,
    height: 22.85,
    viewBox: "0 0 21.996 22.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M10.428,22.85h0A10.571,10.571,0,0,1,6.348,21.8a10.929,10.929,0,0,1-1.772-1.082,11.227,11.227,0,0,1-1.54-1.4,11.457,11.457,0,0,1-1.268-1.668,11.6,11.6,0,0,1-.955-1.9A11.761,11.761,0,0,1,0,11.433a11.952,11.952,0,0,1,.223-2.3A11.706,11.706,0,0,1,.864,6.983,11.584,11.584,0,0,1,1.879,5.041,11.434,11.434,0,0,1,3.222,3.349a11.185,11.185,0,0,1,1.628-1.4A10.876,10.876,0,0,1,6.718.9a10.631,10.631,0,0,1,8.561,0,10.876,10.876,0,0,1,1.868,1.054,11.185,11.185,0,0,1,1.628,1.4,11.434,11.434,0,0,1,1.343,1.692,11.585,11.585,0,0,1,1.014,1.942,11.706,11.706,0,0,1,.641,2.146,11.952,11.952,0,0,1,.223,2.3,11.813,11.813,0,0,1-.613,3.771,11.533,11.533,0,0,1-1.7,3.241,11.219,11.219,0,0,1-2.578,2.5,10.733,10.733,0,0,1-3.249,1.534V14.01h2.86l.429-3.45H13.858v-2.2a1.864,1.864,0,0,1,.305-1.215,1.108,1.108,0,0,1,.5-.343,2.459,2.459,0,0,1,.839-.122H17.26V3.59A23.066,23.066,0,0,0,14.7,3.455c-2.634,0-4.269,1.748-4.269,4.562v2.545H7.562v3.45h2.866V22.85Z",
    fill: "#113f3d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.83b56f809a00546fe5748a7979934a8b.svg";
export { ForwardRef as ReactComponent };